module.exports = __webpack_public_path__ + "img/数据治理_03.e006bfb2.svg";